import { useMemo } from "react";
import { KeywordAssistItem } from "../../types/keyword-assist.type";

interface KADifficultyFilterProps {
  data: KeywordAssistItem[];
  selectedDifficulty: KeywordAssistItem['difficulty'] | 'All';
  onChange: (difficulty: KeywordAssistItem['difficulty'] | 'All') => void;
}

export function KADifficultyFilter({ data, selectedDifficulty, onChange }: KADifficultyFilterProps) {
  // Handle dynamic counts
  const counts = useMemo(() => {
    return {
      All: data.length,
      Strong: data.filter((item) => item.difficulty === 'strong').length,
      Moderate: data.filter((item) => item.difficulty === 'moderate').length,
      Weak: data.filter((item) => item.difficulty === 'weak').length,
    };
  }, [data]);

  return (
    <div className="flex items-center gap-3">
      {/* All Pages Filter */}
      <button
        type="button"
        onClick={() => onChange('All')}
        className={[
          "flex items-center gap-1 text-sm cursor-pointer border rounded-lg px-2 py-1",
          selectedDifficulty === 'All'
            ? "border-[var(--color-purple-strong)] bg-[var(--color-bg-purple-light)] text-[var(--color-purple-strong)] font-semibold shadow-sm"
            : "border-[#E6E6F2] bg-[var(--color-bg-purple-light)] text-[var(--color-purple-strong)] hover:border-[var(--color-purple-strong)]/40"
        ].join(" ")}
      >
        <span className="font-medium">All Pages</span>
        <span>({counts.All})</span>
      </button>

      {/* Strong Filter */}
      <button
        type="button"
        onClick={() => onChange('strong')}
        className={[
          "flex items-center gap-1 text-sm cursor-pointer border rounded-lg px-2 py-1",
          selectedDifficulty === 'strong'
            ? "border-[#1A927B] bg-[#ECFDF3] text-[#1A927B] font-semibold shadow-sm"
            : "border-[#E6E6F2] bg-[#ECFDF3] text-[#1A927B] hover:border-[#1A927B]/40"
        ].join(" ")}
      >
        <span className="font-medium">Strong</span>
        <span>({counts.Strong})</span>
      </button>

      {/* Moderate Filter */}
      <button
        type="button"
        onClick={() => onChange('moderate')}
        className={[
          "flex items-center gap-1 text-sm cursor-pointer border rounded-lg px-2 py-1",
          selectedDifficulty === 'moderate'
            ? "border-[#C4320A] bg-[#FFF6ED] text-[#C4320A] font-semibold shadow-sm"
            : "border-[#E6E6F2] bg-[#FFF6ED] text-[#C4320A] hover:border-[#C4320A]/40"
        ].join(" ")}
      >
        <span className="font-medium">Moderate</span>
        <span>({counts.Moderate})</span>
      </button>

      {/* Weak Filter */}
      <button
        type="button"
        onClick={() => onChange('weak')}
        className={[
          "flex items-center gap-1 text-sm cursor-pointer border rounded-lg px-2 py-1",
          selectedDifficulty === 'weak'
            ? "border-[#B42318] bg-[#FEF3F2] text-[#B42318] font-semibold shadow-sm"
            : "border-[#E6E6F2] bg-[#FEF3F2] text-[#B42318] hover:border-[#B42318]/40"
        ].join(" ")}
      >
        <span className="font-medium">Weak</span>
        <span>({counts.Weak})</span>
      </button>
    </div>
  );
}

export default KADifficultyFilter;
